<template>
  <v-app>
    <v-content>
      <v-container>
        <v-layout text-xs-center>
          <v-flex>
            <img :src="require('@/assets/logo.png')" alt="Posandro Logo Image" width="250">
            <p>Redirecting to our main website in {{ timer }} seconds. Please wait...</p>
            <p>If that doesn't work then you can click on the button...
            <v-btn dark color="green" outline href="https://www.posandro.com">Main Website</v-btn></p>
          </v-flex>
        </v-layout>
        </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      timer: 5
    }
  },
  created () {
    let interval = setInterval(() => {
      this.timer--
      if (this.timer === 0) {
        clearInterval(interval)
        window.location.replace('https://www.posandro.com')
      }
    }, 1000)
  }
}
</script>
